import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import WidgetsStripeCancelForm from './form'
import {logAnalytics, EVENT_TYPES} from 'logAnalytics'


function WidgetsStripeCancel(props) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        document.title = 'Math Makers'

        logAnalytics(EVENT_TYPES.PAGE_VIEW, {page: document.title})

        setMounted(true)
    }, [])

    if (!mounted)
        return <></>

    return (
        <>
            <div className='hero-bg'>
                <div className='form-container'>
                    <WidgetsStripeCancelForm />
                </div>
            </div>
        </>
    )
}

export default withRouter(WidgetsStripeCancel)